import React, { useState, useEffect } from "react";

const FilterTickets = ({ filterVal, setFilterVal, ticketDetails, tickets, setTickets }) => {
    function setSearchFunction(value) {
        setFilterVal(value)
        if (value.trim() === "") {
            setTickets(ticketDetails);
        } else {
            let tempTickets = ticketDetails.filter(val => {
                return (
                    val.ticket_name.toLowerCase().trim().indexOf(value.toLowerCase().trim()) > -1
                );
            });
            setTickets(tempTickets);
        }
    }
    return (
        <div className="w-100 container-fluid pt-3 pb-1">
            <div className="searchIconContainer">
                <input
                    value={filterVal}
                    type="text"
                    className="input w-100 search-input"
                    placeholder="Search for tickets..."
                    onChange={(e) => {
                        setSearchFunction(e.target.value);
                    }}
                />
                <span className="iconRight">
                    <i className="fa fa-search search-icon"></i>
                </span>
            </div>

            <style jsx>{`
        .search-icon {
          color: #fb5850;
        }

        .search-input {
          border: 1px solid rgba(87, 33, 72, 0.37);
          border-radius: 5px;
          padding: 5px 15px;
        }

        .search-input::placeholder {
          color: #aaaaaa;
        }

        .iconRight {
          color: #dbdbdb;
          height: 2.25em;
          cursor: pointer;
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          top: 15px;
          right: 25px;
          width: 2.25em;
          z-index: 4;
        }
      `}</style>
        </div>
    );
};

export default FilterTickets;
